<template>
  <div class="home">
    <topTitle :choosetabs="choosetabs" :userInfoData="userInfo"></topTitle>
    <div class="w-1200 u-flex u-row-between">
      <Carousel v-model="Carousel" loop autoplay :autoplay-speed="5000" style="width: 66%;">
        <CarouselItem v-for="(item, index) in bannerList" :key="index">
          <a :href="item.url"><img :src="item.img" alt="" style="width: 100%; height: auto" /></a>
        </CarouselItem>
      </Carousel>
      <div class="zxxjBox u-flex1">
        <div class="top u-font-weight">在线询价</div>
        <div class="u-flex-1 u-width-100 end">
          <div class="inputBox u-flex">
            <div class="input-title font-15">语种</div>
<!--            <Select v-model="computePrice.languages" style="width: 100%" size="large" placeholder="&#45;&#45;请选择语种&#45;&#45;">-->
<!--              <Option :value="''">&#45;&#45;请选择语种&#45;&#45;</Option>-->
<!--              <Option v-for="item in language" :key="item.id" :value="item.itemCode">{{ item.itemValue }}</Option>-->
<!--            </Select>-->

            <Select v-model="computePrice.languages" style="width: 100%;" size="large" placeholder="--请选择语种--">
              <Option :value="''">--请选择语种--</Option>
              <Option v-for="item in language" :key="item.value" :value="item.text">{{ item.value }}</Option>
            </Select>

          </div>
          <div class="inputBox u-flex">
            <div class="input-title font-15">翻译领域</div>
            <Select v-model="computePrice.domains" style="width: 100%" size="large" placeholder="--请选择翻译领域--">
              <Option :value="''">--请选择翻译领域--</Option>
              <Option v-for="item in domains" :key="item.id" :value="item.field">{{ item.field }}</Option>
            </Select>
          </div>
          <div class="inputBox u-flex">
            <div class="input-title font-15">流程类型</div>
            <Select v-model="computePrice.flows" style="width: 100%" size="large" placeholder="--请选择翻译流程--">
              <Option :value="''">--请选择翻译流程--</Option>
              <Option v-for="item in flows" :key="item.value" :value="item.itemCode">{{ item.itemValue }}</Option>
            </Select>
          </div>
          <div class="inputBox u-flex">
            <div class="input-title font-15">译员等级</div>
            <Select v-model="computePrice.levels" style="width: 100%" size="large" placeholder="--请选择译员等级--">
              <Option :value="''">--请选择译员等级--</Option>
              <Option v-for="item in levels" :key="item.value" :value="item.value">{{ item.text }}</Option>
            </Select>
            <Tooltip content="Bottom Right text" placement="bottom-end" theme="light" class="tool-tip">
              <Button type="text">？</Button>
              <template #content>
                <div class="tool-content">
                  <div>三级：三年相关技术领域翻译经验、通过爱译社考核</div>
                  <div>四级：五年相关技术领域翻译经验、通过爱译社考核</div>
                  <div>五级：十年相关技术领域翻译经验、通过爱译社考核</div>
                </div>
              </template>
            </Tooltip>
          </div>
          <div class="inputBox u-flex">
            <div class="input-title font-15">周期</div>
            <Select v-model="computePrice.periods" style="width: 100%" size="large" placeholder="--请选择翻译周期--">
              <Option :value="''">--请选择翻译周期--</Option>
              <Option v-for="item in periods" :key="item.value" :value="item.text">{{ item.text }}</Option>
            </Select>
            <Tooltip content="Bottom Right text" placement="bottom-end" theme="light" class="tool-tip">
              <Button type="text">？</Button>
              <template #content>
                <div class="tool-content">
                  <div>一般情况:3000字/天(翻译)、6000字天(校对)、8000字/天(审核)</div>
                  <div>加急情况:4000字/天(翻译)、8000字天(校对)、10000字/天(审核)</div>
                  <div>特急情况:5000字/天(翻译)、10000字天(校对)、15000字/天(审核)</div>
                </div>
              </template>
            </Tooltip>
          </div>
          <div class="computeResult">
            <div v-show="computeResult.num != null || computeResult.price != null">可选择译员<span style="color: #ED1C24;">{{
              computeResult.num }}</span>人，约合：<span style="color: #ED1C24;">{{ computeResult.price }}</span>(元/千字)</div>
          </div>
          <Button type="info" @click="jump(null)">快速发布</Button>
        </div>
      </div>
    </div>
    

    <div class="box">
      <div class="u-flex u-row-between dividerBox color-white">
        <div class="divider-left u-flex">
          <div class="dividerBoxTitle">译员展示</div>
          <Icon type="ios-arrow-back" class="cursor" style="margin-right: 40px;" color="#fff" size="28"
            @click="next(1)" />
          <Icon type="ios-arrow-forward" color="#fff" class="cursor" size="28" @click="next(2)" />
          <div class="dividerBoxNum font-14">译员数量：<span>{{ (translatorList.total || 0) + 600 }}</span></div>
        </div>
        <div class="divider-right font-16 cursor" v-if="userType != 5" @click="more">更多>>></div>
      </div>
      <div class="displayBox u-flex u-col-center u-flex-wrap">
        <div class="Interpreter" v-for="(item, index) in translatorList.list" :key="index">
          <div class="name"   :style="{ color: item.reserve9 == 1 ? '#00AA00' : item.reserve9 == 2 ? '#FFBB00' : item.reserve9 == 3 ? '#FF0000':'#000088' }">
            {{ (userType == 3 ? item.realName : item.nickname) || '' }}</div>
          <div class="u-flex tx">
            <img :style="item.gender == 0 ? 'width:110px;' : ''"
              :src="item.userUrl ? item.userUrl : 'http://182.43.222.102:8082/h5/upload/' + item.gender + '.jpg'"
              alt="" />
            <div>
              <div class="xueli" v-if="item.highLevel"
                :style="{ color: item.highLevel == 3 ? '#00AA00' : item.highLevel == 4 ? '#FFBB00' : '#FF0000' }"><span
                  v-for="items in Number(item.highLevel)" :key="items">★</span></div>
              <div class="xueli">{{ item.language }}</div>
              <div class="xueli">{{ item.degree }}</div>
            </div>
          </div>
          <div class="jieshao u-line-1">翻译领域：{{ item.domain }}</div>
          <div class="jieshao u-line-1">翻译经验：{{ item.reserve1 }}</div>
          <div class="jieshao u-line-1">校对经验：{{ item.reserve2 }}</div>
          <div class="jieshao u-line-1" v-if="item.fraction && item.fraction > 0">翻译平均分：{{ item.fraction }}</div>
          <div class="jieshao u-line-1" style="height: 18px;" v-else> </div>
          <div class="u-flex u-width u-row-between InterpreterBtn">
            <div class="chooseTa cursor u-flex1" v-if="userType != 5" @click="jump(item.id)">选TA</div>
            <div class="chooseTa cursor u-flex1" @click="tranDetai(item.id)">详情</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box" v-if="userType == 5">
      <div class="u-flex u-row-between dividerBox color-white">
        <div class="divider-left u-flex">
          <div class="dividerBoxTitle">爱译智能-PAT&nbsp;&nbsp;软件</div>
        </div>
      </div>
      <img class="mb-20" style="margin-top: 50px;" src="http://global.aitrans.org.cn/old/img/Aitrans6.jpg" />
      <div class="pat-box">
        <div class="mb-20 font-18 u-font-weight">
          爱译多语种专业智能软件Aitrans—PAT 软件下载
          <Tooltip content="Bottom Right text" placement="right-end" theme="light" class="">
            <Button type="text">？</Button>
            <template #content>
              <div class="tool-content">
                <div>基础班永久免费，个人版、专业版、企业版每年仅需人民币分别为</div>
                <div>980、1980、2980元，更多优惠请咨询客服!</div>
              </div>
            </template>
          </Tooltip>
        </div>
        <div class="u-flex">
          <div class="pat-info font-14">
            <div v-for="(item, index) in patInfo1" :key="item.text" class="mb-10">
              <span style="color: #999999">{{ item.text }}：</span>
              <span v-if="index != 1">{{ item.value }}</span>
              <a v-else href="http://global.aitrans.org.cn/old/forwardAction/forward_toTeam.do">{{ item.value }}</a>
            </div>
          </div>
          <div class="pat-info font-14">
            <div v-for="(item, index) in patInfo2" :key="item.text" class="mb-10">
              <span style="color: #999999">{{ item.text }}：</span>
              <span v-if="index != 2">{{ item.value }}</span>
              <!-- <Rate v-else v-model="item.value" disabled /> -->
              <div v-else style="display: inline-block;font-size: 16px;"><span style="color: #FFBB00;"
                  v-for="items in item.value" :key="items">★</span></div>
            </div>
          </div>
        </div>
        <div class="u-flex">
          <div class="pat-info">
            <a class="pat-btns cursor" href="http://global.aitrans.org.cn/manager/down/Aitrans-PAT 6.0.zip">本地下载</a>
          </div>
          <div class="pat-info">
            <a class="pat-btns cursor" href="http://global.aitrans.org.cn/old/cilentCustomer/reChargeUI.do">线上购买</a>
            <!-- <a class="pat-btns cursor" @click="error">线上购买</a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="box" v-if="userType == 5">
      <div class="u-flex u-row-between dividerBox color-white mb-20">
        <div class="divider-left u-flex">
          <div class="dividerBoxTitle">软件功能演示</div>
        </div>
        <!-- <span class="tishi">双击视频可以放大</span> -->
      </div>
      <div class="displayBox">
        <Row :gutter="20" type="flex">
          <Col span="12" v-for="(item, index) in videoList" :key="item.id" class="u-flex-column mb-20">
          <h3 class="mb-10">{{ item.itemCode }}</h3>
          <video class="myVideoContent" id="myVideo" style="border: 1px solid rgb(209, 209, 209)" controls width="100%"
            height="350px" :src="item.itemValue" @play="playVideo(index)"></video>
          </Col>
        </Row>
      </div>
    </div>
    <div class="box">
      <div class="u-flex u-row-between dividerBox color-white">
        <div class="divider-left u-flex">
          <div class="dividerBoxTitle">项目展示</div>
          <!-- <Icon type="ios-arrow-back" class="cursor" style="margin-right: 40px;" color="#fff" size="28"
              @click="next(1)" />
            <Icon type="ios-arrow-forward" color="#fff" class="cursor" size="28" @click="next(2)" /> -->

          <Icon type="ios-arrow-back" class="cursor" style="margin-right: 40px;" color="#fff" size="28"
                @click="next2(1)" />
          <Icon type="ios-arrow-forward" color="#fff" class="cursor" size="28" @click="next2(2)" />
          <div class="dividerBoxNum font-14">项目数量：<span>{{ needsList.total }}</span></div>
        </div>

        <div class="divider-right font-16 cursor" @click="toNeeds()">更多>>></div>
      </div>
      <div class="displayBox u-flex u-col-center u-flex-wrap">
        <div class="needsListBox" v-for="(item, index) in needsList.list" :key="index">
<!--
          <div class="needsListBox-title color-black">{{ item.clientCase.projectName.substring(0,15) }}....</div>
-->
          <div class="u-flex">
            <div class="needsList-img">
              <img :src="item.domain" />
<!--
              <div class="cursor" @click="goNeedDetai(item.id)" >查看详情</div>
-->
            </div>
            <div class="needsList-info">
<!--
              <div style="color: #ED1C24;" class="mb-10">￥{{ item.totalMoney }}</div>
-->
              <div class="mb-10">{{ item.languagePair }}</div>
              <div style="color: rgb(0, 0, 255);" class="mb-10">{{ item.length }}字 <span>{{ item.cycle }}</span></div>
              <div class="mb-10">截止日：{{ item.completeTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="u-flex u-row-between dividerBox color-white">
        <div class="divider-left u-flex">
          <div class="dividerBoxTitle">客户展示</div>
        </div>
        <div class="divider-right font-16 cursor">更多>>></div>
      </div>
      <div class="displayBox">
        <Row :gutter="37" type="flex">
          <!-- <Col span="8" v-for="(item, index) in 3" :key="index">
          <div class="projectDisplay u-flex u-row-between">
            <div class="line"></div>
            <div class="">
              <div class="name">英语-日常-仅翻译</div>
              <div class="money">¥0</div>
              <div class="u-flex">
                <div class="dian"></div>
                <span class="one">英汉</span>
              </div>
              <div class="u-flex">
                <div class="dian"></div>
                <span class="one">英汉</span>
              </div>
              <div class="u-flex">
                <div class="dian"></div>
                <div class="u-flex" style="font-size: 18px">
                  <span class="tow">12345</span><span>字</span>
                </div>
                <div class="tow" style="margin-left: 8px">一般</div>
              </div>
              <Button type="info" style="width: 165px;height: 44px;font-size: 20px;margin-top: 20px;">查看详情</Button>
            </div>
            <img src="https://cdn.uviewui.com/uview/swiper/1.jpg" alt="" style="width: 108px; height: 157px" />
          </div>
          </Col> -->
        </Row>
      </div>
    </div>
    <!-- 客服按钮 -->
    <div class="kefu cursor" @click="goPath('/term/toChart.do')">
      <img src="../assets/server.png" />
      <div>官方客服</div>
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
import * as indexData from './config';

import topTitle from "../components/topTitle.vue"
import footerCom from "../components/footerCom.vue"

export default {
  name: "HomeView",
  components: {
    topTitle,
    footerCom
  },
  data() {
    return {
      userType: null,
      inquiryShow: false,
      Carousel: 0,
      choosetabs: '0',
      // token: '',
      pageNum: 1,
      pageNum2: 1,
      translatorList: {},
      needsList: {},
      computePrice: {
        languages: '',
        domains: '',
        flows: '',
        levels: '',
        periods: ''
      },
      // language: {},
      language: indexData.language,

      domains: {},
      flows: {},
      levels: indexData.levels,
      periods: indexData.periods,
      computeResult: {
        num: null,
        price: null
      },
      bannerList: [{
        img: require('/static/uview/index/index1.jpg'),
        url: `${this.$store.state.oldUrl}/forwardAction/forward_toTeam.do`
      }, {
        img: require('/static/uview/index/index2.jpg'),
        url: `${this.$store.state.oldUrl}/forwardAction/forward_toCustomerInstructions.do`
      }, {
        img: require('/static/uview/index/index3.jpg'),
        url: `${this.$store.state.oldUrl}/forwardAction/forward_toInterpreterTips.do`
      }, {
        img: require('/static/uview/index/index4.jpg'),
        url: `http://global.aitrans.org.cn/manager/down/Aitrans-PAT 6.0.zip`
      }],
      patInfo1: indexData.patInfo1,
      patInfo2: indexData.patInfo2,
      videoList: [],
      userInfo: {},
      sliderData: [
        {
          title: '美国作家杰罗姆·大卫·塞林格创作的唯一一部长篇小说',
          link: 'javascript:;'
        },
        {
          title: '首次出版于1951年',
          link: 'javascript:;'
        },
        {
          title: '塞林格将故事的起止局限于16岁的中学生霍尔顿·考尔菲德从离开学校到纽约游荡的三天时间内',
          link: 'javascript:;'
        },
        {
          title: '并借鉴了意识流天马行空的写作方法，充分探索了一个十几岁少年的内心世界',
          link: 'javascript:;'
        },
        {
          title: '愤怒与焦虑是此书的两大主题，主人公的经历和思想在青少年中引起强烈共鸣',
          link: 'javascript:;'
        }
      ]
    };
  },
  created() {
    this.userType = JSON.parse(localStorage.getItem('userinfo')) ? JSON.parse(localStorage.getItem('userinfo')).userType : null
    // this.getLogin()
    this.getDomains()
    // this.getDictByVal()
    this.getFlows()
    this.getInterpreter()
    this.getVideo()
    this.getNeeds()
    this.getInfo()
  },
  watch: {
    pageNum(newVal) {
      console.log(newVal)
      this.getInterpreter()
    },
    pageNum2(newVal) {
      console.log(newVal)
      this.getNeeds()
    },
    computePrice: {
      handler(newVal) {
        console.log(newVal)
        if (newVal.languages == '' && newVal.domains == '' && newVal.flows == '' && newVal.levels == '' && newVal.periods == '') return
        this.getComputePrice()
        this.getInterpreter()
      },
      deep: true
    }
  },
  filters: {
    languageFilter(val) {
      let list = val.split(',')
      let result = []
      list.forEach(item => {
        result.push(item == 'EN' ? '英语' : item == 'JP' ? '日语' : item == 'KOR' ? '韩语' : item == 'FR' ? '法语' : item == 'RUS' ? '俄语' : item == 'GER' ? '德语' : item == 'GF' ? '港繁' : item == 'TF' ? '台繁' : item == 'ES' ? '西班牙' : '')
      })
      return result.join(',')
    }
  },
  methods: {
    getLogin() {
      this.$util.post({
        params: {},
        showLoading: false,
        url: '/dict/checkToken',
        success: (res) => {
          if (res.resultCode == 200) {
            if(res.data == '0') {
              localStorage.removeItem('userinfo')
              localStorage.removeItem('token')
            }
            this.userInfo = JSON.parse(localStorage.getItem('userinfo'))
          }
        }
      });
    },
    // 获取配置
    getConfig(url, dataName, data) {
      this.$util.post({
        params: {
          "data": data
        },
        showLoading: false,
        url,
        success: (res) => {
          if (res.resultCode == 200) {
            this[dataName] = res.data
            // if(dataName == 'language') this.computePrice.languages = res.data[0].itemCode
          } else {
            this.$Message.error('查询失败!');
          }
        },
        error: (err) => {
          console.log('失败', err)
        }
      });
    },
    // 获取翻译领域
    getDomains() {
      this.getConfig('/dict/getDomains', 'domains', {})
    },
    // 获取语种
    getDictByVal() {
      this.getConfig('/dict/getDictByVal', 'language', { name: "快速发布语种" })
    },
    // 获取流程
    getFlows() {
      this.getConfig('/dict/getDictByVal', 'flows', { name: "流程类型" })
    },
    error() {
      this.$Message.info('功能正在开发!');
    },
    // 询价
    getComputePrice() {
      this.$util.post({
        params: {
          "data": {
            "languages": this.computePrice.languages,
            "domains": this.computePrice.domains,
            "flows": this.computePrice.flows,
            "levels": this.computePrice.levels,
            "periods": this.computePrice.periods
          }
        },
        showLoading: true,
        url: '/interpreter/computePrice',
        success: (res) => {
          if (res.resultCode == 200) {
            this.computeResult = res.data
          } else {
            this.$Message.error('查询失败!');
          }
        },
        error: (err) => {
          console.log('失败', err)
        }
      });
    },
    // 查询译员
    getInterpreter() {
      this.$util.post({
        params: {
          "data": {
            "pageNum": this.pageNum,
            "pageSize": 10,
            ...this.computePrice
          }
        },
        url: '/interpreter/queryInterpreter',
        success: (res) => {
          if (res.resultCode == 200) {
            this.translatorList = res.data
          } else {
            this.$Message.error('查询失败!');
          }
        },
        error: (err) => {
          console.log('失败', err)
        }
      });
    },
    more() {
      if (this.userType == 5) return
      this.$router.push({
        path: this.userType == null ? "/login" : "/interpreter",
      });
    },
    // 跳转译员详情
    tranDetai(id) {
      this.$router.push({
        path: `/interpreterDetail/${id}`,
      });
    },

    // 跳转项目展示更多
    toNeeds() {
      this.$router.push({
        path: `/my_proj/toProj`,
      });
    },
    //tiao转项目详情
    goNeedDetai(id) {
      // this.$router.push({
      //   path: `/needsDetail/${id}`,
      // });
    console.log(id)
      let {href} = this.$router.resolve(`/needsDetail/${id}`);
      window.open(href,'_blank')
    },
    // 选TA
    goPath(path, params) {
      console.log(path)
      let data = ''
      if (params) {
        for (let key in params) {
          data += `${key}=${params[key]}`

        }
      }
      // window.location.href = this.$store.state.oldUrl + path + (data == '' ? '' : '?' + data)
      window.open(this.$store.state.oldUrl + path + (data == '' ? '' : '?' + data), "_blank");
    },
    next(type) {
      if (type == 1) {
        if (this.pageNum == 1) return
        this.pageNum--
      } else {
        if (this.translatorList.list.length < 8) {
          this.$Message.error('没有下一页了!');
          return
        }
        this.pageNum++
      }
    },
    next2(type) {
      if (type == 1) {
        if (this.pageNum2 == 1) return
        this.pageNum2--
      } else {
        if (this.needsList.list.length < 8) {
          this.$Message.error('没有下一页了!');
          return
        }
        this.pageNum2++
      }
    },
    // 查询项目
    getNeeds() {
      this.$util.post({
        params: {
          "data": {
            "pageNum": this.pageNum2,
            "pageSize": 8,
          }
        },
        url: '/interpreter/queryNeeds',
        success: (res) => {
          if (res.resultCode == 200) {
            this.needsList = res.data
            console.log(this.needsList.list)
          } else {
            this.$Message.error('查询失败!');
          }
        },
        error: (err) => {
          console.log('失败', err)
        }
      });
    },
    // 查询软件信息
    getInfo() {
      this.$util.post({
        params: {
          "data": {}
        },
        url: '/sysLogin/querySoftInfo',
        success: (res) => {
          if (res.resultCode == '0') {
            this.patInfo1[0].value = res.data.version
            this.patInfo2[0].value = res.data.size
            this.patInfo2[3].value = res.data.releaseTime.slice(0, 10)
          } else {
            this.$Message.error('查询失败!');
          }
        },
        error: (err) => {
          console.log('失败', err)
        }
      });
    },
    // 查询软件功能演示
    getVideo() {
      this.$util.post({
        params: {
          "data": {
            name: '软件功能演示'
          }
        },
        url: '/dict/getDictByName',
        success: (res) => {
          if (res.resultCode == '200') {
            this.videoList = res.data
          } else {
            this.$Message.error('查询失败!');
          }
        },
        error: (err) => {
          console.log('失败', err)
        }
      });
    },
    playVideo(index) {
      console.log(index)
      let videoElement = document.getElementsByClassName('myVideoContent')
      console.log(videoElement)
      if (videoElement && videoElement.length > 0) {
        for (let i = 0; i < videoElement.length; i++) {
          if (i === index) {
            videoElement[i].play()
            this.pauseOtherVideo(videoElement[i])
          }
        }
      }
    },
    pauseOtherVideo(element) {  //暂停播放除element外的其他视频
      let allVideoElement = document.getElementsByTagName('video') // 获取页面上所有的video对象
      if (allVideoElement && allVideoElement.length > 0) {
        for (let i = 0; i < allVideoElement.length; i++) {
          if (allVideoElement[i] != element) {
            allVideoElement[i].pause()
          }
        }
      }
    },
    jump(id) {

      if (!localStorage.getItem('token')) {
        this.$Message.info('请先登录！');
        this.$router.push({
          path: "/login"
        });
        return
      }
      if(!JSON.parse(localStorage.getItem('userinfo')).username) {
        this.$Message.info('请联系项目经理完善资料或者自行修改资料！');
        return
      }
      if(this.userType == 3) {
        // window.location.href = id ? (this.$store.state.oldUrl + '/cilentCustomer/transInfo.do?id=' + id) : 'http://global.aitrans.org.cn/old/cilentCustomer/publishNeed.do'
        window.location.href = id ? (this.$store.state.oldUrl + '/cilentCustomer/transInfo.do?id=' + id) : 'http://global.aitrans.org.cn/#/transMain'
        return
      }
      if(this.userType != 1 && this.userType != 2) {
        this.$Message.info('请以客户角色进行登录！');
        return
      }
      let data = {
        languages: this.computePrice.languages || '中英',
        domains: this.computePrice.domains || '日常',
        flows: this.computePrice.flows || '1',
        levels: '3',
        periods: this.computePrice.periods || '一般'
      }
      this.$Loading.start();
      this.$router.push({
        path: "/placeOrder",
        query: {
          data: JSON.stringify(data),
          id
        }
      });
    },
    handleReachBottom () {
      return new Promise(resolve => {
        setTimeout(() => {
          const last = this.list1[this.list1.length - 1];
          for (let i = 1; i < 11; i++) {
            this.list1.push(last + i);
          }
          resolve();
        }, 2000);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.projectDisplay {
  height: 355px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 11px;
  width: 100%;
  position: relative;
  padding: 34px 42px;

  .dian {
    width: 7px;
    height: 7px;
    background: #1175c0;
    border-radius: 50%;
    margin-right: 8px;
  }

  .tow {
    font-size: 18px;
    color: #5cb85c;
  }

  .one {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .money {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #be0f00;
  }

  .name {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-bottom: 20px;
  }

  .line {
    width: 63px;
    height: 6px;
    background: #38a5e0;
    border-radius: 3px;
    position: absolute;
    left: 42px;
    top: 0;
  }
}

.pat-btns {
  background-color: #5bc0de;
  border-color: #46b8da;
  padding: 10px 25px;
  border-radius: 4px;
  color: #fff !important;
}

.checkMore {
  width: 176px;
  height: 56px;
  border-radius: 41px;
  border: 1px solid #1175c0;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1175c0;
}

.gfkf {
  position: absolute;
  background-color: #ffffff;
  width: 77px;
  height: 230px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(146, 146, 146, 0.5);
  border-radius: 47px;
  z-index: 99;
  top: -110px;
  right: -300px;

  .gfkfText {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #777777;
  }
}

.Interpreter {
  border-radius: 10px;
  width: 210px;
  position: relative;
  padding-right: 5px;
  border: 1px solid #ccc;
  box-shadow: 3px 3px 5px #ccc;
  margin: 10px;
  padding: 15px 10px;

  .InterpreterBtn {
    margin-top: 15px;
  }

  .tx {
    img {
      width: 100px;
      height: 100px;
    }
  }

  .name {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    //color: #2a2c42;
    width: 100%;
    height: 24px;
  }

  .xueli {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    width: 100%;
    margin: 10px;
  }

  .jieshao {
    margin: 10px 0;
    font-size: 12px;
  }

  .chooseTa {
    width: 58px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 0 15px;
    font-size: 12px;
  }

  .chooseTa:hover {
    color: red;
  }
}

.box {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.divider {
  flex-grow: 1;
  height: 1px;
  background: #38a5e0;
}

.dividerBox {
  padding: 0 30px;
  background-color: #08A5E0;
  height: 60px;
  margin-top: 30px;
  border-radius: 5px;
  position: relative;

  .tishi {
    position: absolute;
    bottom: -4px;
    left: 50px;
  }

  .dividerBoxNum {
    margin-left: 25px;
    align-self: flex-end;

    span {
      margin: 0 20px;
      color: red;
    }
  }
}

.dividerBoxTitle {
  margin-right: 50px;
  font-size: 24px;
  font-family: Helvetica;
}

.displayBox {
  width: 100%;
  margin: 20px 0 40px;
  padding: 0 22px;

  .icon {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
}

.zxxjBox {
  display: flex;
  flex-direction: column;

  .top {
    text-align: center;
    height: 15px;
    line-height: 15px;
    color: #CC0000;
  }

  .end {
    padding: 15px;
    display: flex;
    flex-direction: column;

    .inputBox {
      margin-bottom: 15px;
      height: 34px;
      position: relative;

      .input-title {
        width: 30%;
        text-align: right;
        padding: 0 15px;
      }
    }
  }
}

.tool-tip {
  position: absolute;
  right: -30px;
}

.tool-content {
  background-color: #08a5e0;
  color: #fff;
}

::v-deep .ivu-btn-text {
  color: rgb(255, 0, 0);
  font-weight: bold;
  font-size: 18px;
}

::v-deep .ivu-btn-text:hover {
  color: rgb(255, 0, 0);
}

::v-deep .ivu-select {
  padding: 0 15px;
}

::v-deep.ivu-select-large.ivu-select-single .ivu-select-selection {
  padding: 0 12px;
  height: 34px;
}

::v-deep .ivu-select-placeholder,
::v-deep .ivu-select-selected-value {
  height: 34px !important;
  font-size: 13px !important;
  line-height: 34px !important;
}

::v-deep .ivu-carousel-dots li button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  // margin-right: 32px;
}

::v-deep .ivu-carousel-dots li.ivu-carousel-active>button {
  width: 10px;
  background-color: #fff;
}

::v-deep .ivu-carousel-dots-inside {
  bottom: 45px;
}

::v-deep .ivu-btn-info {
  width: 50%;
  height: 34px;
  font-size: 14px;
  border-radius: 4px;
  color: #1b6d85;
  background-color: #fff;
  margin: 0 auto;
  align-self: center;
}

.computeResult {
  height: 34px;
  margin-left: 45px;
}

::v-deep .ivu-tooltip-inner {
  background-color: #08a5e0;
  max-width: 100%;
}

::v-deep .ivu-tooltip-light .ivu-tooltip-inner {
  background-color: #08a5e0;
}

.pat-box {
  padding-left: 70px;

  .pat-info {
    width: 210px;
    margin: 0 10px;

    div {
      height: 33px;
    }

    a {
      color: #222222;
    }
  }
}

.needsListBox {
  width: 271px;
  margin: 30px 15px 0 0;
  border: 1px solid #ccc;
  box-shadow: 3px 3px 10px #ccc;
  border-radius: 10px;

  .needsListBox-title {
    text-align: center;
    line-height: 30px;
    border-bottom: 1px solid #ccc;
  }

  .needsList-img {
    width: 80px;
    text-align: center;
    border-right: 1px solid #ccc;
    padding-bottom: 5px;
  }

  .needsList-info {
    padding-top: 20px;
    padding-left: 20px;

    span {
      color: rgb(0, 128, 0);
    }
  }
}

.kefu {
  position: fixed;
  right: 10%;
  top: 30%;
  z-index: 999;
  box-shadow: -2px 0 30px 2px rgb(97 105 119 / 18%);
  border-radius: 18px;
  padding: 20px 5px;
  text-align: center;
  background-color: #fff;
  font-size: 12px;

  img {
    height: 24px;
  }
}

.time{
  font-size: 14px;
  font-weight: bold;
}
.content{
  padding-left: 5px;
}


::v-deep .ivu-select-dropdown {
  width: inherit;
  max-height: 550px !important;
  overflow: auto;
  margin: 5px 0;
  padding: 5px 0;
  //background-color: #fff;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  position: absolute;
  z-index: 900;
}

a {
  text-decoration: none;

}
</style>
